module.exports = __webpack_public_path__ + "static/img-hexapod-mobile@3x-5a03e68d7f79b3a92c9374a007fe5dbb.jpg";